;(function() {
  'use strict'

  angular.module('core.surveyCard', [])
})()
